import { EVENTS } from 'consts/metricsTrackingEvents';
import { MODULES } from 'consts/modules';
import { trackEvent } from 'utils/metricsTracking';

export const trackNavLoginClick = () => {
  trackEvent(EVENTS.loginClicked, {
    path:
      typeof window !== 'undefined' ? window.location.pathname : 'unknown-path',
    module: MODULES.navigation,
  });
};
